interface AnimatedSvgPathProps {
  path: string;
  duration?: number;
  strokeWidth?: number;
  color?: string;
}

export function AnimatedPath({
  path,
  duration = 2.5,
  strokeWidth = 3,
  color,
}: AnimatedSvgPathProps) {
  const id = Math.random().toString(36).slice(2);
  const YELLOW = color ?? "#facc15";

  return (
    <svg
      width="100%"
      height="100%"
      style={{ overflow: "visible", position: "absolute" }}
    >
      <defs>
        {/* ================= GLOW FILTER ================= */}
        <filter id={`glow-${id}`} x="-60%" y="-60%" width="220%" height="220%">
          <feGaussianBlur stdDeviation="5" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>

        {/* ================= TRAILING GRADIENT ================= */}
        <linearGradient
          id={`grad-${id}`}
          gradientUnits="objectBoundingBox"
          x1="0"
          y1="0"
          x2="1"
          y2="0"
        >
          <stop offset="0%" stopColor={YELLOW} stopOpacity="1" />
          <stop offset="40%" stopColor={YELLOW} stopOpacity="0.6" />
          <stop offset="70%" stopColor={YELLOW} stopOpacity="0.25" />
          <stop offset="100%" stopColor={YELLOW} stopOpacity="0" />

          {/* ===== FILL (move gradient) ===== */}
          <animateTransform
            attributeName="gradientTransform"
            type="translate"
            from="-1.2 0"
            to="0.2 0"
            dur={`${duration}s`}
            repeatCount="indefinite"
            keyTimes="0;0.4;0.6;1"
            values="
      -1.2 0;
      0.2 0;
      0.2 0;
      -1.2 0
    "
            calcMode="spline"
            keySplines="
      0.4 0 0.2 1;
      0 0 1 1;
      0.4 0 0.2 1
    "
          />

          {/* ===== REMOVE (fade out) ===== */}
          <animate
            attributeName="stop-opacity"
            dur={`${duration}s`}
            repeatCount="indefinite"
            keyTimes="0;0.6;0.8;1"
            values="1;1;0;0"
          />
        </linearGradient>
      </defs>

      {/* ================= BASE PATH ================= */}
      <path
        d={path}
        fill="none"
        stroke={YELLOW}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        opacity={0.2}
        shapeRendering="geometricPrecision"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      />

      {/* ================= GLOW TRAIL (APPEARS AFTER) ================= */}
      <path
        d={path}
        fill="none"
        stroke={`url(#grad-${id})`}
        strokeWidth={strokeWidth - 0.5}
        strokeLinecap="round"
        strokeDasharray={0}
        filter={`url(#glow-${id})`}
        vectorEffect="non-scaling-stroke"
        shapeRendering="geometricPrecision"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      />
    </svg>
  );
}
